import { isDefined } from '@freelancer/utils';
import type {
  ServiceOfferingApi,
  ServiceOfferingDiscountDetailsApi,
} from 'api-typings/service_offerings/service_offerings';
import { transformServiceOfferingShopCategoryServicePriceType } from '../service-offering-shop-category-services';
import type {
  ServiceOffering,
  ServiceOfferingDiscountDetails,
} from './service-offerings.model';

export function transformServiceOffering(
  serviceOffering: ServiceOfferingApi,
): ServiceOffering {
  return {
    id: serviceOffering.id,
    creatorId: serviceOffering.creator_id,
    description: serviceOffering.description,
    richDescription: serviceOffering.rich_description,
    status: serviceOffering.status,
    title: serviceOffering.title,
    createDate: isDefined(serviceOffering.create_date)
      ? serviceOffering.create_date * 1000
      : undefined,
    jobIds: serviceOffering.jobs?.map(job => job.id),
    seoUrl: serviceOffering.seo_url,
    // T290741 Filter should happen in the backend
    attachments: serviceOffering.attachments?.filter(
      attachment => !attachment.delete_date,
    ),
    duration: serviceOffering.duration,
    price: serviceOffering.price,
    priceType: transformServiceOfferingShopCategoryServicePriceType(
      serviceOffering.price_type,
    ),
    discountDetails: isDefined(serviceOffering.discount_details)
      ? transformServiceOfferingDiscountDetails(
          serviceOffering.discount_details,
        )
      : undefined,
  };
}

export function transformServiceOfferingDiscountDetails(
  discountDetails: ServiceOfferingDiscountDetailsApi,
): ServiceOfferingDiscountDetails {
  return {
    discountType: discountDetails.discount_type,
    discountValue: discountDetails.discount_value,
    discountedPrice: discountDetails.discounted_price,
    validFrom: discountDetails.valid_from * 1000,
    validUntil: discountDetails.valid_until * 1000,
  };
}
